import { render, staticRenderFns } from "./CoupleBack.vue?vue&type=template&id=a5c3034a&scoped=true"
import script from "./CoupleBack.vue?vue&type=script&lang=js"
export * from "./CoupleBack.vue?vue&type=script&lang=js"
import style0 from "./CoupleBack.vue?vue&type=style&index=0&id=a5c3034a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c3034a",
  null
  
)

export default component.exports